/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelTipoPraticaIstitutoPlessoAssegnazioneDTO } from '../model/paged-model-tipo-pratica-istituto-plesso-assegnazione-dto';
// @ts-ignore
import { TipoPraticaIstitutoPlessoAssegnazioneCreationForm } from '../model/tipo-pratica-istituto-plesso-assegnazione-creation-form';
// @ts-ignore
import { TipoPraticaIstitutoPlessoAssegnazioneDTO } from '../model/tipo-pratica-istituto-plesso-assegnazione-dto';
// @ts-ignore
import { TipoPraticaIstitutoPlessoAssegnazioneListFilter } from '../model/tipo-pratica-istituto-plesso-assegnazione-list-filter';
// @ts-ignore
import { TipoPraticaIstitutoPlessoAssegnazionePatchForm } from '../model/tipo-pratica-istituto-plesso-assegnazione-patch-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TipoPraticaIstitutoPlessoAssegnazioneControllerServiceInterface,
    CreateTipoPraticaIstitutoPlessoAssegnazioneRequestParams,
    DeleteTipoPraticaIstitutoPlessoAssegnazioneRequestParams,
    GetTipoPraticaIstitutoPlessoAssegnazioneRequestParams,
    ListTipoPraticaIstitutoPlessoAssegnazioniRequestParams,
    UpdateTipoPraticaIstitutoPlessoAssegnazioneRequestParams
} from './tipo-pratica-istituto-plesso-assegnazione-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TipoPraticaIstitutoPlessoAssegnazioneControllerService extends BaseService implements TipoPraticaIstitutoPlessoAssegnazioneControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Crea una nuova Assegnazione (classe, sezione) sotto un Plesso
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createTipoPraticaIstitutoPlessoAssegnazione(requestParameters: CreateTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaIstitutoPlessoAssegnazioneDTO>;
    public createTipoPraticaIstitutoPlessoAssegnazione(requestParameters: CreateTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaIstitutoPlessoAssegnazioneDTO>>;
    public createTipoPraticaIstitutoPlessoAssegnazione(requestParameters: CreateTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaIstitutoPlessoAssegnazioneDTO>>;
    public createTipoPraticaIstitutoPlessoAssegnazione(requestParameters: CreateTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling createTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling createTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling createTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const tipoPraticaIstitutoPlessoAssegnazioneCreationForm = requestParameters?.tipoPraticaIstitutoPlessoAssegnazioneCreationForm;
        if (tipoPraticaIstitutoPlessoAssegnazioneCreationForm === null || tipoPraticaIstitutoPlessoAssegnazioneCreationForm === undefined) {
            throw new Error('Required parameter tipoPraticaIstitutoPlessoAssegnazioneCreationForm was null or undefined when calling createTipoPraticaIstitutoPlessoAssegnazione.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assegnazioni`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaIstitutoPlessoAssegnazioneDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaIstitutoPlessoAssegnazioneCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina un\&#39;Assegnazione
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteTipoPraticaIstitutoPlessoAssegnazione(requestParameters: DeleteTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteTipoPraticaIstitutoPlessoAssegnazione(requestParameters: DeleteTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteTipoPraticaIstitutoPlessoAssegnazione(requestParameters: DeleteTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteTipoPraticaIstitutoPlessoAssegnazione(requestParameters: DeleteTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling deleteTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling deleteTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling deleteTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const idAssegnazione = requestParameters?.idAssegnazione;
        if (idAssegnazione === null || idAssegnazione === undefined) {
            throw new Error('Required parameter idAssegnazione was null or undefined when calling deleteTipoPraticaIstitutoPlessoAssegnazione.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assegnazioni/${this.configuration.encodeParam({name: "idAssegnazione", value: idAssegnazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di un\&#39;Assegnazione per id
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getTipoPraticaIstitutoPlessoAssegnazione(requestParameters: GetTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaIstitutoPlessoAssegnazioneDTO>;
    public getTipoPraticaIstitutoPlessoAssegnazione(requestParameters: GetTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaIstitutoPlessoAssegnazioneDTO>>;
    public getTipoPraticaIstitutoPlessoAssegnazione(requestParameters: GetTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaIstitutoPlessoAssegnazioneDTO>>;
    public getTipoPraticaIstitutoPlessoAssegnazione(requestParameters: GetTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling getTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling getTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const idAssegnazione = requestParameters?.idAssegnazione;
        if (idAssegnazione === null || idAssegnazione === undefined) {
            throw new Error('Required parameter idAssegnazione was null or undefined when calling getTipoPraticaIstitutoPlessoAssegnazione.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assegnazioni/${this.configuration.encodeParam({name: "idAssegnazione", value: idAssegnazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaIstitutoPlessoAssegnazioneDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata delle Assegnazioni di un Plesso (filtri: classe, sezione, attivo, con_contributo)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listTipoPraticaIstitutoPlessoAssegnazioni(requestParameters: ListTipoPraticaIstitutoPlessoAssegnazioniRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelTipoPraticaIstitutoPlessoAssegnazioneDTO>;
    public listTipoPraticaIstitutoPlessoAssegnazioni(requestParameters: ListTipoPraticaIstitutoPlessoAssegnazioniRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelTipoPraticaIstitutoPlessoAssegnazioneDTO>>;
    public listTipoPraticaIstitutoPlessoAssegnazioni(requestParameters: ListTipoPraticaIstitutoPlessoAssegnazioniRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelTipoPraticaIstitutoPlessoAssegnazioneDTO>>;
    public listTipoPraticaIstitutoPlessoAssegnazioni(requestParameters: ListTipoPraticaIstitutoPlessoAssegnazioniRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listTipoPraticaIstitutoPlessoAssegnazioni.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling listTipoPraticaIstitutoPlessoAssegnazioni.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling listTipoPraticaIstitutoPlessoAssegnazioni.');
        }
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listTipoPraticaIstitutoPlessoAssegnazioni.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listTipoPraticaIstitutoPlessoAssegnazioni.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assegnazioni`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelTipoPraticaIstitutoPlessoAssegnazioneDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replace di un\&#39;Assegnazione (richiede version per optimistic lock)
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateTipoPraticaIstitutoPlessoAssegnazione(requestParameters: UpdateTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaIstitutoPlessoAssegnazioneDTO>;
    public updateTipoPraticaIstitutoPlessoAssegnazione(requestParameters: UpdateTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaIstitutoPlessoAssegnazioneDTO>>;
    public updateTipoPraticaIstitutoPlessoAssegnazione(requestParameters: UpdateTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaIstitutoPlessoAssegnazioneDTO>>;
    public updateTipoPraticaIstitutoPlessoAssegnazione(requestParameters: UpdateTipoPraticaIstitutoPlessoAssegnazioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling updateTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling updateTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling updateTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const idAssegnazione = requestParameters?.idAssegnazione;
        if (idAssegnazione === null || idAssegnazione === undefined) {
            throw new Error('Required parameter idAssegnazione was null or undefined when calling updateTipoPraticaIstitutoPlessoAssegnazione.');
        }
        const tipoPraticaIstitutoPlessoAssegnazionePatchForm = requestParameters?.tipoPraticaIstitutoPlessoAssegnazionePatchForm;
        if (tipoPraticaIstitutoPlessoAssegnazionePatchForm === null || tipoPraticaIstitutoPlessoAssegnazionePatchForm === undefined) {
            throw new Error('Required parameter tipoPraticaIstitutoPlessoAssegnazionePatchForm was null or undefined when calling updateTipoPraticaIstitutoPlessoAssegnazione.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assegnazioni/${this.configuration.encodeParam({name: "idAssegnazione", value: idAssegnazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaIstitutoPlessoAssegnazioneDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaIstitutoPlessoAssegnazionePatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
